import React from "react";
import classes from "./InputItem.scss";
import { colors } from "Constants";
import { Checkbox } from "@toddle-edu/ds-web";
import {
  DOC_EDITOR_STYLES,
  DOC_EDITOR_OVERRIDE_ELEMENTS,
} from "Worksheet/modules/WorksheetConstants";
import RichTextEditor from "UIComponents/RichTextEditor";
import DocEditor from "UIComponents/DocEditor";

class InputItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.textArea = null;

    this.state = { isEditing: false, defaultValue: "" };
  }

  onTextAreaChange = value => {
    const { updateListValue, index } = this.props;
    updateListValue({ text: value, index: index, action: "EDIT" });
  };

  toggleInputSelection = () => {
    const { updateListValue, index, isSelected } = this.props;
    updateListValue({
      isSelected: !isSelected,
      index: index,
      action: "SELECTION",
    });
  };

  onEnterPress = value => {
    const {
      updateListValue,
      index,
      isLast,
      onItemBlur,
      id,
      shouldCreateOnEnter,
    } = this.props;

    if (value && isLast && shouldCreateOnEnter) {
      updateListValue({
        text: "",
        index: index + 1,
        action: "ADD",
      });
    } else {
      onItemBlur?.({ id, index });
    }
  };

  inputRef = ref => {
    this.textArea = ref;
  };

  focus = () => {
    this.textArea?.focus?.();
  };

  blur = () => {
    this.textArea?.blur?.();
  };

  handleKeyDown = event => {
    if (event?.keyCode == 13) {
      event.preventDefault();
      this.onEnterPress(event.target.value);
    }
  };

  renderDocEditor = () => {
    const {
      value,
      onBlur,
      onFocus,
      placeholder,
      isAIEnabledInRTE,
      extendedToolbarButtons,
    } = this.props;

    const config = {
      floatingToolbar: {
        AI: {
          isEnabled: isAIEnabledInRTE,
        },
      },
    };

    return (
      <DocEditor
        value={value}
        updateInputField={(value, isEmpty) => {
          this.onTextAreaChange(isEmpty ? "" : value);
        }}
        onFocusInputField={onFocus}
        onBlurInputField={onBlur}
        readOnly={false}
        viewOnly={false}
        config={config}
        showDragHandles={true}
        isCompact={true}
        compactVariantMinHeight={150}
        isDropdownBodyLevel={true}
        isTableSizeContained={true}
        tableMaxWidth={620}
        tableDefaultWidth={300}
        placeholder={placeholder}
        shouldCallOnBlur={false}
        hideErrorMessage={true}
        containerStyle={DOC_EDITOR_STYLES.CONTAINER_STYLES}
        compactVariantStyles={DOC_EDITOR_STYLES.COMPACT_VARIANT_STYLES}
        isExtendedToolbarEnabled={true}
        extendedToolbarButtons={extendedToolbarButtons}
        isMathsEquationEnabled={true}
        saveDelay={300}
        overrideElements={DOC_EDITOR_OVERRIDE_ELEMENTS}
      />
    );
  };

  render = () => {
    const {
      placeholder,
      value,
      isEditing,
      onBlur,
      onFocus,
      mode,
      isSelected,
      isCurrentFocused,
      showLexicalRTE = true,
      showDocEditor,
    } = this.props;

    return (
      <div className={classes.container}>
        <div
          className={classes.textAreaContainer}
          style={isCurrentFocused ? { borderColor: colors.neutral400 } : {}}
        >
          {!isEditing && mode !== "view" && (
            <Checkbox
              isChecked={isSelected}
              _legacy_size={"xx-small"}
              dsVersion="2.0"
              size="medium"
              onChange={this.toggleInputSelection}
              testId="worksheet-inputItem-inputSelection"
            />
          )}

          <div className={classes.inputContainer}>
            {showDocEditor ? (
              this.renderDocEditor()
            ) : (
              <RichTextEditor
                mode="edit"
                width={"100%"}
                height={92}
                updateInputField={this.onTextAreaChange}
                onFocusInputField={onFocus}
                onBlurInputField={onBlur}
                value={value}
                customRef={this.inputRef}
                placeholder={placeholder}
                renderNewEditor={true}
                shouldCallOnBlur={false}
                showLexicalRTE={showLexicalRTE}
                testId="worksheet-inputItem-richTextEditor"
                hideErrorMessage={true}
                toolbarPosition="bottom"
              />
            )}
          </div>
        </div>
      </div>
    );
  };

  UNSAFE_componentWillReceiveProps = nextProps => {
    if (nextProps.isEditing !== this.props.isEditing && nextProps.isEditing) {
      this.setState({ defaultValue: this.props.value });
    }
  };
}

export default InputItem;
